var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48359(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48359",
    "data-name": "Group 48359",
    transform: "translate(-1795 -1537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39150",
    "data-name": "Path 39150",
    d: "M7.833,63.833H29.62l-1.667,5.833H21.833V72H52.167V69.667h-6.12l-1.667-5.833H66.167A5.84,5.84,0,0,0,72,58V7.833A5.84,5.84,0,0,0,66.167,2H7.833A5.84,5.84,0,0,0,2,7.833V58A5.84,5.84,0,0,0,7.833,63.833ZM43.62,69.667H30.38l1.667-5.833h9.906ZM66.167,61.5H7.833a3.5,3.5,0,0,1-3.5-3.5V56.833H69.667V58A3.5,3.5,0,0,1,66.167,61.5ZM7.833,4.333H66.167a3.5,3.5,0,0,1,3.5,3.5V54.5H4.333V7.833A3.5,3.5,0,0,1,7.833,4.333Z",
    transform: "translate(1793 1535)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39151",
    "data-name": "Path 39151",
    d: "M26.8,26.94a1.189,1.189,0,0,0,.369.06,1.169,1.169,0,0,0,.933-.467L39.287,11.616a1.165,1.165,0,0,0-.232-1.632A19.653,19.653,0,0,0,27.167,6,1.167,1.167,0,0,0,26,7.167V25.833A1.167,1.167,0,0,0,26.8,26.94ZM28.333,8.372A17.273,17.273,0,0,1,36.7,11.179L28.333,22.333Z",
    transform: "translate(1797 1535.667)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39152",
    "data-name": "Path 39152",
    d: "M29.05,27.979a1.163,1.163,0,0,0,.946.485,1.189,1.189,0,0,0,.369-.059l17.7-5.9a1.166,1.166,0,0,0,.737-1.476,19.757,19.757,0,0,0-6.918-9.581,1.186,1.186,0,0,0-.866-.223,1.169,1.169,0,0,0-.769.455L29.062,26.6A1.164,1.164,0,0,0,29.05,27.979ZM41.394,14.045a17.415,17.415,0,0,1,4.789,6.627L33.17,25.01Z",
    transform: "translate(1797.471 1536.536)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39153",
    "data-name": "Path 39153",
    d: "M11.266,40.655a1.164,1.164,0,0,0,.728-.256L26.563,28.744A1.167,1.167,0,0,0,27,27.833V9.167A1.167,1.167,0,0,0,25.833,8,19.856,19.856,0,0,0,6,27.833a19.615,19.615,0,0,0,4.355,12.384A1.166,1.166,0,0,0,11.266,40.655Zm13.4-30.283v16.9L11.476,37.826a17.274,17.274,0,0,1-3.143-9.993A17.524,17.524,0,0,1,24.667,10.372Z",
    transform: "translate(1793.667 1536)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39154",
    "data-name": "Path 39154",
    d: "M11.206,39.693a1.166,1.166,0,0,0,.25.858,19.82,19.82,0,0,0,29.5,1.64,1.165,1.165,0,0,0,0-1.65l-13.2-13.2a1.164,1.164,0,0,0-1.554-.086L11.638,38.911A1.164,1.164,0,0,0,11.206,39.693ZM26.847,29.73,38.457,41.34a17.485,17.485,0,0,1-24.421-1.36Z",
    transform: "translate(1794.533 1539.167)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39155",
    "data-name": "Path 39155",
    d: "M30.8,28.96a1.167,1.167,0,0,0-.456,1.932l13.2,13.2a1.166,1.166,0,0,0,1.65,0A19.78,19.78,0,0,0,49.973,23.8,1.163,1.163,0,0,0,48.5,23.06ZM44.339,41.59,33.327,30.578l14.767-4.922A17.446,17.446,0,0,1,44.339,41.59Z",
    transform: "translate(1797.667 1538.5)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148114",
    "data-name": "Rectangle 148114",
    width: 2,
    height: 2,
    transform: "translate(1849 1543)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148115",
    "data-name": "Rectangle 148115",
    width: 2,
    height: 2,
    transform: "translate(1849 1548)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148116",
    "data-name": "Rectangle 148116",
    width: 2,
    height: 3,
    transform: "translate(1849 1552)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148117",
    "data-name": "Rectangle 148117",
    width: 2,
    height: 2,
    transform: "translate(1849 1557)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148118",
    "data-name": "Rectangle 148118",
    width: 7,
    height: 2,
    transform: "translate(1853 1543)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148119",
    "data-name": "Rectangle 148119",
    width: 7,
    height: 2,
    transform: "translate(1853 1548)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148120",
    "data-name": "Rectangle 148120",
    width: 7,
    height: 3,
    transform: "translate(1853 1552)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148121",
    "data-name": "Rectangle 148121",
    width: 7,
    height: 2,
    transform: "translate(1853 1557)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148122",
    "data-name": "Rectangle 148122",
    width: 2,
    height: 2,
    transform: "translate(1858 1585)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148123",
    "data-name": "Rectangle 148123",
    width: 3,
    height: 2,
    transform: "translate(1853 1585)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148124",
    "data-name": "Rectangle 148124",
    width: 2,
    height: 2,
    transform: "translate(1849 1585)",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48359);
export default __webpack_public_path__ + "static/media/Group 48359.3db9032690a85ceef2a9a6a8f88d199c.svg";
export { ForwardRef as ReactComponent };